/**
 * 这个应用的皮肤。
 *
 * 皮肤 = 一整套设计 token（配色 + 字阶 + 间距 + 圆角 + 阴影 + 动效 + 层级）。
 * `@pwaship/ui` 的所有组件只读这些 token，所以换皮肤不需要动任何组件。
 *
 * 三种用法，按需要的自由度从小到大：
 *
 * 1. **只换品牌色** —— 下面 `brand` 那样，改 accent 一组六个值。九成项目到这里就够了。
 * 2. **换整套配色** —— 把 `light` / `dark` 写全（照着 `defaultSkin` 的槽位）。
 * 3. **连形状也换** —— 再给 `shape`（圆角、字阶、间距、动效时长……）。
 *
 * ⚠️ **light 和 dark 都要给。** 只改浅色的话，用户切到深色会看到上一套皮肤的强调色；
 * 而开发时如果一直在浅色下工作，这个问题要等用户报障才会知道。
 *
 * 改完直接生效，没有代码生成步骤：`SkinProvider` 会在第一次渲染前把这些皮肤的 CSS
 * 注入 `<head>`。首屏由 `@pwaship/ui/styles.css` 里的默认皮肤兜底，不存在没有样式的那一帧。
 */

import { defineSkin, defaultSkin, type Skin } from '@pwaship/ui'

/** 你的品牌皮肤。改这里。 */
export const brand = defineSkin({
  name: 'brand',
  label: '默认',
  light: {
    accent: '#C2683E',
    accentHover: '#C2683E',
    accentActive: '#C2683E',
    // accentSoft / accentLine 是淡底与描边，通常取品牌色的很浅一档
    // accentSoft: '#f6e6dc',
    // accentLine: '#e8cdbc',
    // onAccent: '#ffffff',
  },
  dark: {
    // ⚠️ 深色底上品牌色通常要**提亮一档**，直接复用浅色那个值会读不出来
    // accent: '#e08658',
  },
})

/**
 * 这个应用提供哪些皮肤。第一套是默认。
 *
 * 想让用户能切换，就在这里多放几套（`defineSkin` 定义，或直接用框架自带的
 * `oceanSkin` / `forestSkin` / `nightSkin`），设置页里放一个 `<SkinPicker />`。
 * 只有一套时 `<SkinPicker modeOnly />` 会只显示明暗三档。
 */
export const skins: readonly Skin[] = [brand]

/** 兜底：万一 `skins` 被清空，至少界面还有 token */
export const fallbackSkin = skins[0] ?? defaultSkin
